import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    &:hover,\n    &:focus {\n      background-color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  padding: 4px;\n  margin: -4px;\n  border-radius: 6px;\n  background: none;\n  cursor: pointer;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { PureComponent } from "react";
import styled, { css } from "styled-components";

var IconButtonComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(IconButtonComponent, _PureComponent);

  function IconButtonComponent() {
    _classCallCheck(this, IconButtonComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconButtonComponent).apply(this, arguments));
  }

  _createClass(IconButtonComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          forwardRef = _this$props.forwardRef,
          props = _objectWithoutProperties(_this$props, ["children", "forwardRef"]);

      return React.createElement(StyledIconButton, _extends({
        ref: forwardRef
      }, props), children);
    }
  }]);

  return IconButtonComponent;
}(PureComponent);

var IconButton = React.forwardRef(function (props, ref) {
  return React.createElement(IconButtonComponent, _extends({
    forwardRef: ref
  }, props));
});
export default IconButton;
export var StyledIconButton = styled.button(_templateObject(), function (props) {
  return props.hover && css(_templateObject2(), props.theme.color("background", "primary:darken"));
});